import { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
import { BaseButton, ButtonState } from 'components/Shared/Buttons';

const LP_ID = 'LP_DIV_1666982920443';

export default function Help(): JSX.Element {
  const { t } = useTranslation();
  const [isLiveChatInView, setIsLiveChatInView] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          setIsLiveChatInView(true);
          observer.disconnect();
        }
      });
    });

    const addObserverIfNodeAvailable = (): void => {
      const liveChatDiv = document.querySelector(`#${LP_ID}`);
      if (!liveChatDiv) {
        window.setTimeout(addObserverIfNodeAvailable, 500);
        return;
      }
      observer.observe(liveChatDiv, { childList: true });
    };

    addObserverIfNodeAvailable();
  });

  return (
    <div className="outer-container">
      <div className="container">
        <div className="row">
          <div className="col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
            <div className="message-container">
              <h1>{t('help.generalQuestions')}</h1>
              <div className="copy-container">
                {ReactHtmlParser(t('help.generalQuestionsText'))}
              </div>
              {!isLiveChatInView && (
                <BaseButton state={ButtonState.thinking} className="loading-button" />
              )}
              <div className="button-container" id={LP_ID}></div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .message-container {
          padding: 85px 0;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0.2px;
        }

        h1,
        h2 {
          font-size: 24px;
          margin: 0 0 22px 0;
          font-weight: 600;
        }

        .copy-container {
          padding-bottom: 8px;
        }
      `}</style>
    </div>
  );
}
